import Api from 'app/services/Api'
import ErrorHandler, { isErrorHandlerType } from 'app/services/ErrorHandler'
import { useGetGuestTokenMutation } from 'app/services/Query/user/user.mutation'
import Storage from 'app/services/Storage'
import useAuthStore, {
  getAuthActions,
  getAuthMethods
} from 'app/store/auth.store'
import { STORAGE_KEYS } from 'app/utils/constants/storage.constants'
import { hasGuestStatus } from 'app/utils/helpers/user.helpers'

const useGuestAuth = () => {
  const actions = useAuthStore(getAuthActions)
  const methods = useAuthStore(getAuthMethods)
  const { mutateAsync } = useGetGuestTokenMutation()

  const removeGuestToken = () => {
    Storage.removeItem(STORAGE_KEYS.accessToken)

    methods.resetStore()

    if (Api.setAuthToken) {
      Api.setAuthToken(undefined)
    }
  }

  const checkGuestTokenExpiration = async () => {
    const tokenData = await methods.getTokenData()
    const isGuestUser = hasGuestStatus(tokenData.status)
    const isExpiredToken = tokenData.exp > Date.now()

    const isGuestExpired = isGuestUser && isExpiredToken

    if (isGuestExpired) {
      removeGuestToken()
    }

    return isGuestExpired || !tokenData.exp
  }

  const getGuestUser = async () => {
    try {
      const needNewToken = await checkGuestTokenExpiration()

      if (needNewToken) {
        const { jwt_token: token } = await mutateAsync()

        await actions.authorize(token)
      }
    } catch (error) {
      if (isErrorHandlerType(error)) new ErrorHandler(error?.data)
    }
  }

  return { getGuestUser }
}

export default useGuestAuth
